import { useIntl } from 'react-intl';
import { IconLanguage, IconSwitchLanguageSecondary } from '@/icons';
import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';
import CustomSelect from '@/ui/Select/Select';
import HorizontalDivider from '@/ui/HorizontalDivider';
import { ActionSwitchLanguageNodeType } from '../../Nodes/types';
import { GeneralSettingsType, LanguageOptions } from '../types';
import { StyledSettings, StyledSettingsContent } from '../styles';
import FAQSection from '../FAQSection';

function SwitchLanguageSettings({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  settings,
  selectedNode,
  updateNodeData,
  disabled,
}: {
  settings: GeneralSettingsType;
  selectedNode: ActionSwitchLanguageNodeType;
  updateNodeData: (id: string, newData: any) => void;
  disabled?: boolean;
}) {
  const intl = useIntl();

  const faqs = [
    {
      question: intl.formatMessage({
        defaultMessage: 'What to consider when switching languages ?',
        id: 'F00ZNx',
      }),
      answer: intl.formatMessage({
        defaultMessage:
          'Using the switch language block requires you to enable the Multi Language Support feature in the CMS. Make sure to enable it before using this block.',
        id: 'j/pU+R',
      }),
    },
    {
      question: intl.formatMessage({
        defaultMessage: 'How does switching languages work?',
        id: 'EMhJAt',
      }),
      answer: intl.formatMessage({
        defaultMessage:
          'Switch Language is used to switch the language of the system. You can select from the available languages in the settings.',
        id: 'irw2SZ',
      }),
    },
  ];
  const relevantData = selectedNode.data.options;

  return (
    <StyledSettings data-testid="action-switchLanguage-settings">
      <Flex align="center" gap={8}>
        <IconSwitchLanguageSecondary />
        <Flex direction="column">
          <T h3>
            {intl.formatMessage({
              defaultMessage: 'Switch Language',
              id: '+Ez+iF',
            })}
          </T>
        </Flex>
      </Flex>
      <StyledSettingsContent>
        <Flex direction="column" gap={8}>
          <Flex justify="space-between" align="center">
            <T body1>
              {intl.formatMessage({
                defaultMessage: 'Target Language',
                id: 'NU4hHH',
              })}
            </T>
            <CustomSelect
              disabled={disabled ?? false}
              required
              icon={<IconLanguage />}
              isSearchable={false}
              size="small"
              placeholder={intl.formatMessage({
                defaultMessage: 'Language',
                id: 'y1Z3or',
              })}
              options={LanguageOptions.filter(
                (lang) => lang.value !== null,
              ).map((lang) => ({
                label: lang.value,
                value: lang.value,
              }))}
              value={
                relevantData.targetLanguage
                  ? {
                      label: relevantData.targetLanguage,
                      value: relevantData.targetLanguage,
                    }
                  : null
              }
              onChange={(e) => {
                updateNodeData(selectedNode.id, {
                  ...selectedNode.data,
                  options: {
                    ...relevantData,
                    targetLanguage: e?.value,
                  },
                });
              }}
            />
          </Flex>
        </Flex>
      </StyledSettingsContent>
      <HorizontalDivider />
      <FAQSection faqs={faqs} />
    </StyledSettings>
  );
}
export default SwitchLanguageSettings;
